module.exports = __webpack_public_path__ + "media/Components/Logos/icon-text-left-75d13626b9c770534ec28ac447bb849e.svg";